document.addEventListener('DOMContentLoaded', function () {
  const splide_ref = new Splide('.featured-product-ref-slider', {
    perPage: 1,
    arrows: true,
    pagination: false
  });
  const thumbs_ref = new Splide('.featured-table-slider',{
    perPage: 3,
    arrows: false,
    pagination: false,
    drag: false,
    autoWidth: true,
    breakpoints: {
      1023: {
        perPage: 1,
        pagination: false,
        autoWidth: false,
        drag: true
      }
    }
  })

  splide_ref.sync(thumbs_ref);
  thumbs_ref.mount();
  splide_ref.mount();

});